






import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class share extends Vue {
  @Prop({}) videoInfo!: any;
  mounted() {}
  closeShare() {
    this.$emit("changeShare", false);
  }
}
